// One viewport screenshot as a JPEG File (html2canvas, lazy-loaded). Shared
// by the copilot's 📷 button and the Report-a-bug dialog. `ignore` is the
// selector list for chrome that must not appear in the picture (the panel
// taking the shot, floating launchers). WebGL rooms render blank — known
// html2canvas limit.
export const SCREEN_IGNORE = '.cp-panel, .cp-fab, .anr, .va-panel, .va-launcher, .nv-stage-strip, .nv-stage-ticker, .bug-dialog-backdrop';

export async function captureScreen({ ignore = SCREEN_IGNORE, maxWidth = 1400, quality = 0.75, name } = {}) {
  const { default: html2canvas } = await import('html2canvas');
  const canvas = await html2canvas(document.body, {
    x: window.scrollX, y: window.scrollY, width: window.innerWidth, height: window.innerHeight,
    logging: false, useCORS: true,
    ignoreElements: (el) => el.closest?.(ignore) != null,
  });
  let out = canvas;
  if (canvas.width > maxWidth) {
    out = document.createElement('canvas');
    out.width = maxWidth;
    out.height = Math.round(canvas.height * (maxWidth / canvas.width));
    out.getContext('2d').drawImage(canvas, 0, 0, out.width, out.height);
  }
  const blob = await new Promise((resolve) => out.toBlob(resolve, 'image/jpeg', quality));
  if (!blob) throw new Error('could not capture the screen');
  const fileName = name || `screen-${Date.now()}.jpg`;
  return new File([blob], fileName, { type: 'image/jpeg' });
}
